import { observer } from 'mobx-react-lite'
import React from 'react'
import Divider from '@mui/material/Divider'

import { useCategoryStore, useScreenSize, useSettingsStore } from '../../../../common'
import { type TransactionRule } from '../../../../core'

import EditRuleDetails from '../components/EditRuleDetails'
import RuleListItem from '../components/RuleListItem'
import { useCategoryUiStore } from '../../../../categories'

interface ActionProps {
  rule: TransactionRule
}

const EditRuleAction: React.FC<ActionProps> = observer(({ rule }) => {
  const { categories } = useCategoryStore()
  const { setSelectedGuid } = useCategoryUiStore()
  const { deleteTransactionRule, setSelectedRule } = useSettingsStore()
  const { isDesktop, isTablet } = useScreenSize()
  const [isOpen, setIsOpen] = React.useState(false)

  const handleClose = (): void => {
    setIsOpen(false)
    setSelectedGuid(null) // this resets the selected value in the category selector drawer when the edit rule drawer closes
    setSelectedRule(undefined)
  }

  const handleDelete = async () => {
    await deleteTransactionRule()
    handleClose()
  }

  const handleOpen = (): void => {
    setIsOpen(true)
    setSelectedRule(rule)
  }

  const getCategoryName = (categoryGuid: string) => {
    return categories.find((category) => category.guid === categoryGuid)?.name
  }

  return (
    <React.Fragment>
      <RuleListItem
        onClick={handleOpen}
        primaryText={rule.description ? rule.description : rule.match_description}
        secondaryText={rule.category_guid ? getCategoryName(rule.category_guid) : ''}
      />
      <Divider sx={{ ml: isTablet || isDesktop ? 0 : 24 }} />
      <EditRuleDetails isOpen={isOpen} onClose={handleClose} onDelete={handleDelete} />
    </React.Fragment>
  )
})

export default EditRuleAction
